var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Instagram"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13 1.33336H5C2.79086 1.33336 1 3.12422 1 5.33336V13.3334C1 15.5425 2.79086 17.3334 5 17.3334H13C15.2091 17.3334 17 15.5425 17 13.3334V5.33336C17 3.12422 15.2091 1.33336 13 1.33336Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.2973 8.84443C12.4001 9.53797 12.2816 10.2463 11.9587 10.8686C11.6358 11.4909 11.1249 11.9956 10.4986 12.3108C9.87236 12.626 9.16264 12.7358 8.47042 12.6244C7.77821 12.513 7.13874 12.1862 6.64297 11.6904C6.1472 11.1946 5.82038 10.5552 5.70899 9.86294C5.59761 9.17073 5.70733 8.46101 6.02254 7.83475C6.33776 7.20848 6.84243 6.69755 7.46476 6.37464C8.08709 6.05172 8.7954 5.93326 9.48893 6.0361C10.1964 6.14101 10.8513 6.47066 11.357 6.97636C11.8627 7.48206 12.1924 8.137 12.2973 8.84443Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/Instagram.84d9460891fb25f0514516d05f3b19c3.svg";
export { ForwardRef as ReactComponent };